import { render, staticRenderFns } from "./ArticlesCard.vue?vue&type=template&id=b9b059a6&"
import script from "./ArticlesCard.vue?vue&type=script&lang=js&"
export * from "./ArticlesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports